import { render, staticRenderFns } from "./TourAIAssistant2.vue?vue&type=template&id=2285ed58&scoped=true&"
import script from "./TourAIAssistant2.vue?vue&type=script&lang=js&"
export * from "./TourAIAssistant2.vue?vue&type=script&lang=js&"
import style0 from "./TourAIAssistant2.vue?vue&type=style&index=0&id=2285ed58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285ed58",
  null
  
)

export default component.exports